export default "__VITE_ASSET__fbb23ae1__"